import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/cbs";
import { GET_CATEGORIES } from "@/http/requests/cbs/category_gql";
import { GET_DEVICES_STATUS, GET_DEVICES_DASHBOARD } from "@/http/requests/cbs/device_gql";

export default {
	initData(payload) {
		const queryOptions = {
			query: gql`query DashboardDeviceListManagement ($limit: Int!, $page: Int!, $sensor_has_data: Boolean) {
					${GET_DEVICES_DASHBOARD}
					${GET_DEVICES_STATUS}
					${GET_CATEGORIES}
				}
				${fragments.DeviceDashboard}
				${fragments.DeviceStatus}
				${fragments.Category}
				${fragments.Kpi}
				${fragments.KpiTaskDetail}
			`,
			variables: {
				page: payload.page || 1,
				limit: payload.limit || -1,
				sensor_has_data: payload.sensor_has_data
			}
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				totalDevices: response.data.devices.total,
				devices: response.data.devices.data,
				categories: response.data.categories.data,
				devicesStatus: response.data.device_statuses || []
			};
		});
	}
};
